<template lang="pug">
  .profile-page__main
    notification-list(
    v-if="notifications.length > 0"
    :notifications="notifications"
    :on-close-notification="closeNotification"
    :on-filter-notification="filterNotification"
    )
    .profile-page__header
      .profile-page__title
        h1.title {{ operatorPageData.title }}
    .profile-page__body
      .operator-table
        .operator-table__button-create
          router-link.button.button_paint-main.button_long(
          :to="{name: 'ManagerCreateRequest'}"
          ) Создать заявку
        .operator-table__filter
          .form
            .form__elem
              multiselect.custom-multiselect(
              v-model="defaultValues.status"
              placeholder="Введите статус",
              :options="statusListData"
              :label="'text'"
              :id="'status'"
              :multiple="false"
              :showLabels="false"
              :closeOnSelect="true"
              :allowEmpty="false"
              @select="changeSelectValue"
              )
                template(
                  slot="noOptions"
                ) Список пуст
                template(
                  slot="noResult"
                ) Ничего не найдено
            .form__elem
              multiselect.custom-multiselect(
              v-model="fields.shift"
              placeholder="Введите название смены",
              :options="shiftsListData"
              :label="'text'"
              :id="'shift'"
              :multiple="false"
              :showLabels="false"
              :closeOnSelect="true"
              :allowEmpty="false"
              @select="changeSelectValue"
              )
                template(
                  slot="noOptions"
                ) Список пуст
                template(
                  slot="noResult"
                ) Ничего не найдено
            .form__elem
              multiselect.custom-multiselect(
              v-model="fields.quota"
              placeholder="Введите название квоты",
              :options="quotasListData"
              :label="'text'"
              :id="'quota'"
              :multiple="false"
              :showLabels="false"
              :closeOnSelect="true"
              :allowEmpty="false"
              @select="changeSelectValue"
              :disabled="quotaSelectDisabled"
              )
                template(
                  slot="noOptions"
                ) Список пуст
                template(
                  slot="noResult"
                ) Ничего не найдено

            .form__elem
              input.input.input_full(
              placeholder="Поиск по ФИО"
              v-model="fields.fio"
              v-on:keyup="onKeyUpFio()"
              )
            .form__elem
              .form-elem
                .form-elem__body
                  .form-elem-list
                    .form-elem-list__item
                      label.input-item
                        .input-item__input
                          .checkbox
                            input.checkbox__input(
                            type="checkbox"
                            v-model="fields.priority"
                            @change="filterTable"
                            )
                            .checkbox__icon
                        .input-item__body
                          .input-item__text Высокий приоритет

        .operator-table__table
          table-component(
          :thead-data="tableHead"
          :tbody-data="ordersData"
          )
        //- .operator-table__pagination
        //-   pagination
        //- .operator-table__button
        //-   button.button.button_paint-main.button_long
        //-     .button__text Сохранить
</template>

<script>
import {mapState, mapActions} from "vuex";

import TableComponent from "@/components/table/Table";
import Pagination from "./components/Pagination";
import NotificationList from "./components/NotificationList";
import Multiselect from "vue-multiselect";

export default {
  name: "OperatorRequests",
  components: {
    NotificationList,
    Pagination,
    TableComponent,
    Multiselect
  },
  data() {
    return {
      operatorPageData: {
        title: "Заявки"
      },
      shiftsListData: [],
      quotasListData: [],
      defaultValues: {
        status: {
          value: null,
          text: "Все статусы"
        },
        shift: {
          value: null,
          text: "Все смены"
        },
        quota: {
          value: null,
          text: "Все квоты"
        }
      },
      fields: {
        status: null,
        shift: null,
        quota: null,
        fio: "",
        priority: false
      },
      tableHead: [
        {
          type: "text",
          text: "Статус заявки",
          key: "statusName",
          enableClass: true,
          class: "statusClass"
        },
        {
          type: "link",
          url: "request_link",
          text: "Номер заявки",
          key: "_id"
        },
        {
          type: "text",
          text: "Кол-во баллов",
          key: "points"
        },
        {
          type: "text",
          // url: "shift_url",
          text: "Смена",
          key: "shift_name",
          cut: true,
          enableTitle: true
        },
        {
          type: "text",
          text: "Квота",
          key: "quota_name",
          cut: true,
          enableTitle: true
        },
        {
          type: "text",
          text: "Дата подачи",
          key: "date"
        },
        {
          type: "text",
          text: "ФИО",
          key: "child_name",
          cut: true,
          enableTitle: true
        }
      ],
      ordersData: [],
      notifications: [],
      typingInterval: null
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    requestOrders() {
      return this.$store.getters.requestOrders();
    },
    statusListData() {
      const statusList = JSON.parse(JSON.stringify(this.catalogue.orderStatuses));
      const unnecessaryStatusList = [
        "adjustment",
        "repeated",
        "completed",
        "unknown"
      ];
      statusList.unshift({value: null, text: "Все статусы"});
      for (var i = 0; i < statusList.length; i++) {
        for (var j = 0; j < unnecessaryStatusList.length; j++) {
          if (statusList[i].value === unnecessaryStatusList[j]) {
            statusList.splice(i, 1);
          }
        }
      }
      return statusList;
    },
    quotaSelectDisabled() {
      return this.fields.shift && !this.fields.shift.value;
    }
  },
  methods: {
    ...mapActions(["getOrders", "getShifts", "getNotifications", "getQuotas"]),
    onKeyUpFio() {
      clearInterval(this.typingInterval);
      this.typingInterval = setInterval(() => {
        clearInterval(this.typingInterval);
        this.filterTable();
      }, 500);
    },
    closeNotification(notification) {
      this.notifications = this.notifications.filter(
        el => el._id !== notification._id
      );
    },
    filterNotification(notification) {
      if (
        notification.notification_type === 1 ||
        notification.notification_type === 3
      ) {
        this.defaultValues.status.value = "new";
        this.defaultValues.status.text = "Новая";
        this.defaultValues.status.server_value = "1";
      } else {
        this.defaultValues.status.value = "rejected_by_user";
        this.defaultValues.status.text = "Отклонена пользователем";
        this.defaultValues.status.server_value = "12";
      }
      this.filterTable();
      this.closeNotification(notification);
    },
    changeSelectValue(data, type) {
      this.fields[type] = data;
      this.filterTable();
      if (type === "shift") {
        this.setQuotaListData();
      }
    },
    filterTable() {
      this.$root.$emit("on-show-preloader");
      const filter = {};
      if (this.fields.status && this.fields.status.value !== null) {
        filter.statuses = this.fields.status.server_value;
      }
      if (this.fields.shift && this.fields.shift.value !== null) {
        filter.campshift = this.fields.shift.value;
      }
      if (this.fields.quota && this.fields.quota.value !== null) {
        filter.quota = this.fields.quota.value;
      }
      filter.fio = this.fields.fio;
      if (this.fields.priority) {
        filter.high_priority = this.fields.priority;
      }

      this.getOrders(filter).then(ordersData => {
        this.ordersData = ordersData.map(order => {
          order.date = new Date(order.date_created).toLocaleDateString("ru");
          order.shift_name = order.campshift.name;
          order.shift_url = `/pages/shifts/${order.campshift.id}/`;
          order.quota_name = order.quotashouse.quota_name;
          order.child_name = `${order.child.last_name} ${
            order.child.first_name
            } ${order.child.fathers_name}`;
          order._id = `#${order.id}`;
          order.request_link = `/pages/manager/requests/${order.id}/`;
          order.statusClass = `status ${
            this.requestOrders[order.status].value
            }`;
          order.statusName = `${this.requestOrders[order.status].text}`;
          return order;
        }, []);
        this.$root.$emit("on-hide-preloader");
      });
    },
    setQuotaListData() {
      this.quotasListData = [this.defaultValues.quota];
      this.fields.quota = this.defaultValues.quota;
      if (this.fields.shift && this.fields.shift.value) {
        this.getQuotas({
          campshift: this.fields.shift.value
        }).then(res => {
          const quotas = res.map(quota => ({
            text: quota.name,
            value: quota.id
          }));
          this.quotasListData.push(...quotas);
        });
      }
    },
    setFields() {
      this.fields.shift = this.defaultValues.shift;
      this.fields.quota = this.defaultValues.quota;
      this.fields.status = this.defaultValues.status;
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    this.setFields();

    this.filterTable();

    this.getShifts().then(shiftsData => {
      this.shiftsListData.push(this.defaultValues.shift);
      const shifts = shiftsData.results.map(shift => ({
        text: shift.name,
        value: shift.id
      }));
      this.shiftsListData.push(...shifts);
    });

    this.getNotifications().then(notData => {
      this.notifications = notData.map((notification, index) => {
        notification._id = index;
        if (notification.notification_type === 1) {
          notification.icon = require("@/assets/images/icons/notif-check.svg");
          notification.color = "turquoise";
        } else if (notification.notification_type === 2) {
          notification.icon = require("@/assets/images/icons/notif-cross.svg");
          notification.color = "orange";
        } else {
          notification.icon = require("@/assets/images/icons/notif-clock.svg");
          notification.color = "red";
        }
        return notification;
      });
    });
  }
};
</script>
